import ReportsSerializer from './base';

export default class ReportFeedback extends ReportsSerializer {}
